import { useSlideContext } from "@/components/Product/ProductSlider/components/slider/components/slides/components/slide/context/slide.context";

import { ProductTile } from "./components/productTile/productTile";
import { Base } from "./slide.base";

export const Slide = Object.assign(Base, {
    useContext: useSlideContext,
    ProductTile: ProductTile
});
